import { useFooterConfig } from '~/scopes/footer/composables/useFooterConfig'

export function useHomeSocialMeta(): Record<string, string> {
  const { columns } = useFooterConfig()

  const socials: Record<string, string> = {}

  for (const column of columns.value) {
    if (column.socials) {
      for (const social of column.socials) {
        socials[social.name] = social.href
      }
    }
  }

  return socials
}
